const localeFor = (lang) =>
  lang === "tr" ? "tr-TR" : lang === "fa" ? "fa-IR" : "en-US";

export const startOfWeek = (date) => {
  const day = new Date(date);
  day.setHours(0, 0, 0, 0);
  const fromSaturday = (day.getDay() + 1) % 7;
  day.setDate(day.getDate() - fromSaturday);
  return day;
};

const CHIP_KEYS = [
  [],
  ["week.chipStory"],
  ["week.chipRate"],
  ["week.chipReels"],
  ["week.chipPost", "week.chipLive"],
  ["week.chipReport"],
  [],
];

export const buildWeekDays = (t, lang, now = new Date()) => {
  const locale = localeFor(lang);
  const start = startOfWeek(now);
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const weekday = new Intl.DateTimeFormat(locale, { weekday: "short" });
  const dayNum = new Intl.DateTimeFormat(locale, { day: "numeric" });

  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(start);
    date.setDate(start.getDate() + index);
    return {
      key: date.toISOString().slice(0, 10),
      name: weekday.format(date),
      date: dayNum.format(date),
      chips: CHIP_KEYS[index].map((key) => t(key)),
      today: date.getTime() === today.getTime(),
    };
  });
};

export const formatMonthYear = (lang, now = new Date()) =>
  new Intl.DateTimeFormat(localeFor(lang), {
    month: "long",
    year: "numeric",
  }).format(now);

export const formatWeekLabel = (t, lang, now = new Date()) => {
  const start = startOfWeek(now);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  const fmt = new Intl.DateTimeFormat(localeFor(lang), {
    month: "short",
    day: "numeric",
  });
  return `${t("week.label")} · ${fmt.format(start)} – ${fmt.format(end)}`;
};

export const noteDayLabel = (t, lang, offset, now = new Date()) => {
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const date = new Date(today);
  date.setDate(today.getDate() + Number(offset || 0));
  if (Number(offset) === 0) return t("time.today");
  if (Number(offset) === 1) return t("time.tomorrow");
  return new Intl.DateTimeFormat(localeFor(lang), {
    weekday: "long",
  }).format(date);
};
